exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flex-row,.flex-row-center{display:flex;flex-direction:row;align-items:center}.flex-row-center{justify-content:center}.flex-row-between{justify-content:space-between}.flex-row-around,.flex-row-between{display:flex;flex-direction:row;align-items:center}.flex-row-around{justify-content:space-around}.flex-row-end{display:flex;flex-direction:row;align-items:center;justify-content:flex-end}.flex-column,.flex-column-center{display:flex;flex-direction:column}.flex-column-center{justify-content:center}.flex-column-between{display:flex;flex-direction:column;justify-content:space-between}.margin-10{margin:10px}.margin-top-10{margin-top:10px}.margin-right-10{margin-right:10px}.margin-bottom-10{margin-bottom:10px}.margin-left-10{margin-left:10px}.margin-20{margin:20px}.margin-top-20{margin-top:20px}.margin-right-20{margin-right:20px}.margin-bottom-20{margin-bottom:20px}.margin-left-20{margin-left:20px}.gap-10{gap:10px}.gap-20{gap:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/modules/layout.css
// module id = 652
// module chunks = 0